import RandingStyle9 from "../../randing/RandingStyle9";

function Randing101({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle9
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/101/20250219_01.jpg`}
      formFieldColor="white"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/navy/applyBenefitButton.png`}
      callNumber={"tel:032-567-8528"}
      // privacyMessage="개인정보수집에 동의하시는 분만 '상담문의' 버튼을 눌러주세요."
      eventDates={true}
      periodType="month"
      companyName="검단뉴욕치과의원"
      footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/geomdan2.jpg`}
    />
  );
}

export default Randing101;
